import { render, staticRenderFns } from "./DiemDenAnToanList.vue?vue&type=template&id=f195a526&"
import script from "./DiemDenAnToanList.vue?vue&type=script&lang=js&"
export * from "./DiemDenAnToanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports